<template>
  <b-card>
    <b-form-file
        v-model="file"
        :state="Boolean(file)"
        accept=".csv"
        :placeholder="$t('components.import_controls.escolha_planilha')"
        class="mb-2 w-50"
    ></b-form-file>
    <a href="" class="ml-2">{{ $t('components.import_controls.baixar_planilha') }}</a>
    <b-progress :value="progress.value" :max="progress.max" :hidden="progress.hidden" show-progress
                animated></b-progress>

    <div class="mt-3" v-if="file">{{ $t('components.import_controls.planilha_selecionada') }}: {{ file.name }}</div>
    <hr>
    <div>
      <h3>{{ $t('components.import_controls.selecione_integacoes') }}</h3>
      <b-form-select id="integracao_cliente" v-model="selected_integracao_cliente" :options="newIntegrations"
                     class="w-25">{{ $t('components.import_controls.integracao_cliente') }}
      </b-form-select>
      <span class="ml-2 mr-2">---</span>
      <b-form-select id="integracao_suporte" v-model="selected_integracao_suporte" :options="supportIntegrations"
                     class="w-25">{{ $t('components.import_controls.integracao_suporte') }}
      </b-form-select>
    </div>
    <b-button class="mt-3" @click="processCsv()">
      {{ $t('components.import_controls.importar_exames') }}
    </b-button>
  </b-card>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';

export default {
  name: "ImportControls",
  computed: {
    ...mapGetters({
      newIntegrations: 'tuevs/getCompanies',
      supportIntegrations: 'tuevs/getSupportCompanies'
    })
  },
  data() {
    return {
      file: null,
      selected_integracao_cliente: null,
      selected_integracao_suporte: null,
      progress: {
        value: 0,
        max: 100,
        hidden: true
      },
    }
  },
  methods: {
    ...mapActions([
      'tuevs/getCompanies',
      'tuevs/getSupportCompanies',
      'tuevs/importExams'
    ]),
    onComplete(results) {
      let payload = {
        company_id: this.selected_integracao_cliente
        , support_lab_id: this.selected_integracao_suporte
        , data: results.data
      };

      this['tuevs/importExams'](payload);

    },
    onChunk(result, parser) {
      // Set progress bar
      this.progress.hidden = false;
      this.progress.value = Math.round((result.meta.cursor / this.progress.max) * 100);
    },
    processCsv() {
      if (this.file) {
        this.$papa.parse(this.file, {
          header: true,
          skipEmptyLines: true,
          // step: this.onChunk,
          complete: (results, file) => {
            this.onComplete(results)
          }
        });
      }
    }
  },
  mounted() {
    this.newIntegrations[1] ?? this['tuevs/getCompanies']();
    this.newIntegrations[1] ?? this['tuevs/getSupportCompanies']();
  }
}
</script>
